import { FC } from 'react';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import UserInput from 'v3/common/components/UserInput';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import Button from 'v3/common/components/Button';

const Zerodha: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles }) => {
  const { reDirectPage, updatePartialConfigs, changeApiKey, validateClientIdAndRedirect, isMobile } =
    brokerSpecificHandles;
  const {
    clientId,
    isLoading,
    isClientValidated,
    shouldShowApiKey,
    shouldShowSecretKey,
    apiKey,
    secretKey,
    selectedBrokerConfig,
  } = userConfigs;
  const broker = selectedBrokerConfig?.id;

  return (
    <form
      id={`${broker}-form`}
      onSubmit={(e) => {
        e.preventDefault();
        return isClientValidated ? reDirectPage({}, false) : validateClientIdAndRedirect();
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Client Id"
        id={`${broker}-client-id`}
        value={clientId}
        isDisabled={isClientValidated}
        placeholder="Enter Client Id"
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
      />

      {!isClientValidated && clientId && (
        <button type="button" onClick={changeApiKey}>
          <i className="fa-regular fa-gear fa-spin" />
          Change API details?
        </button>
      )}

      {shouldShowApiKey && (
        <UserInput
          labelValue="API Key"
          id={`${broker}-api-key`}
          value={apiKey}
          placeholder="Enter API Key"
          onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
        />
      )}

      {shouldShowSecretKey && (
        <UserInput
          labelValue="API Secret"
          id={`${broker}-secret-key`}
          value={secretKey}
          placeholder="Enter API Secret"
          onHandleChange={(value) => updatePartialConfigs({ secretKey: value })}
        />
      )}

      <div className="alert alert-warning">
        Login via Zerodha using your Zerodha API key/secret. <br />
        (API key/secret required only for the first time).
      </div>

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-form`} type="submit" isLoading={isLoading}>
          {isClientValidated ? 'Login' : 'Validate'}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default Zerodha;
